import { SearchField } from "./SearchField.jsx";

export function TypeCatalogToolbar({ search, onSearchChange, placeholder, countLabel, c }) {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, padding: "12px 14px", borderBottom: `1px solid ${c.divider}`, background: c.hover, flexWrap: "wrap" }}>
      <SearchField value={search} onChange={onSearchChange} placeholder={placeholder} variant="catalog" />
      <span style={{ fontSize: 11.5, fontWeight: 600, color: c.sub, whiteSpace: "nowrap" }}>{countLabel}</span>
    </div>
  );
}

export function TypeCatalogListFooter({ c, children }) {
  return (
    <div style={{ padding: "10px 14px", borderTop: `1px solid ${c.divider}`, fontSize: 11, color: c.sub, background: c.hover }}>
      {children}
    </div>
  );
}

export function TypeCatalogSectionHeader({ title, subtitle, action, c }) {
  return (
    <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12, marginBottom: 14, flexWrap: "wrap" }}>
      <div>
        <h2 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: c.text }}>{title}</h2>
        {subtitle ? <p style={{ margin: "4px 0 0", fontSize: 12, color: c.sub, maxWidth: 560, lineHeight: 1.5 }}>{subtitle}</p> : null}
      </div>
      {action}
    </div>
  );
}

export function TypeCatalogCard({ ap, dark, children }) {
  return (
    <div
      style={{
        background: ap.card,
        border: `1px solid ${ap.cardBorder}`,
        borderRadius: 12,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 320,
        boxShadow: dark ? "0 8px 24px rgba(0,0,0,.2)" : "0 8px 24px rgba(15,23,42,.06)",
      }}
    >
      {children}
    </div>
  );
}

export function PageErrorBanner({ message }) {
  if (!message) return null;
  return <p style={{ margin: "0 0 10px", fontSize: 12, color: "#EF4444", fontWeight: 600 }}>{message}</p>;
}
